import { Card, CardContent, Button } from "@repo/ui";
import { Headset, Mail } from "lucide-react";

export function BillingSupportCard() {
  return (
    <Card className="border-dashed">
      <CardContent className="pt-6">
        <div className="flex items-start gap-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-500/10">
            <Headset className="h-5 w-5 text-amber-600" />
          </div>
          <div className="space-y-3">
            <div>
              <p className="text-sm font-medium">
                Need to change or cancel your plan?
              </p>
              <p className="text-sm text-muted-foreground">
                Plan changes and cancellations are handled by our support team
                to protect your compliance data and audit trail access.
              </p>
            </div>
            <Button variant="ghost" size="sm" asChild>
              <a href="mailto:support@c2vault.com">
                <Mail className="mr-2 h-4 w-4" />
                support@c2vault.com
              </a>
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
